import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-[#E6E9EF] bg-white px-3 py-2 shadow-lg">
      <p className="text-[11px] font-semibold text-[#0C1120]">{label}</p>
      <p className="text-[13px] font-bold text-[#572B7C]" style={{ fontFamily: "Poppins,sans-serif" }}>
        {payload[0].value} jobs
      </p>
    </div>
  );
};

const DashboardGeographicChart = ({ jobsByState, loading, isDark }) => {
  if (loading) return <div className="sz-card h-[300px] animate-pulse" />;

  const data = (jobsByState || []).slice(0, 8).map((s) => ({
    state: s.state,
    count: s.count,
  }));

  return (
    <section className="sz-card" style={{ padding: "20px 22px" }}>
      <h3 className="text-[15px] font-bold text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif" }}>
        Jobs by State
      </h3>
      <div className="mt-[3px] text-[12px] text-[#8A90A2]">Top regions by job volume</div>

      {data.length === 0 ? (
        <div className="flex h-[220px] items-center justify-center text-[13px] text-[#8A90A2]">
          No geographic data yet
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={Math.max(180, data.length * 34)}>
          <BarChart data={data} layout="vertical" margin={{ top: 16, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="szStateBar" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="#572B7C" />
                <stop offset="100%" stopColor="#28C0D0" />
              </linearGradient>
            </defs>
            <XAxis type="number" hide />
            <YAxis
              type="category"
              dataKey="state"
              tick={{ fontSize: 12, fill: "#2B3142", fontWeight: 600 }}
              tickLine={false}
              axisLine={false}
              width={42}
            />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: "#F1F3F7" }} />
            <Bar dataKey="count" radius={[999, 999, 999, 999]} barSize={9} background={{ fill: "#F1F3F7", radius: 999 }}>
              {data.map((_, i) => (
                <Cell key={i} fill="url(#szStateBar)" />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </section>
  );
};

export default DashboardGeographicChart;
